module.exports = __webpack_public_path__ + "img/fushimi-HP-nyuka-006.d2295dfd.jpg";